import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
  FETCH_NEW_BOOKINGS_SUCCESS,
  FETCH_ORDER_LIST_QUEUE,
  FETCH_ORDER_LIST_QUEUE_SUCCESS,
  FETCH_ORDER_LIST_QUEUE_FAILED
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from '../config/configureFirebase';
import { onValue, runTransaction, get, off, push, query, orderByChild, equalTo } from "firebase/database";

export const fetchTasks = () => (dispatch) => {
  const { auth, tasksRef } = firebase;

  const uid = auth.currentUser.uid;
  off(tasksRef());
  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });
  onValue(tasksRef(), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data)
        .filter(
          (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
        )
        .map((i) => {
          data[i].id = i;
          return data[i];
        });
        const userInfo = store.getState().auth.profile;
        let heatpoints = [];
        let bookings = Object.values(snapshot.val());
        for (let i = 0; i < bookings.length; i++) {
          if(bookings[i].status == 'NEW' && ((userInfo.hasOwnProperty('carType') && userInfo.carType === bookings[i].carType) || !userInfo.hasOwnProperty('carType'))){
            heatpoints.push({latitude: bookings[i].pickup.lat, longitude: bookings[i].pickup.lng, weight: 1})
          }
        }
        dispatch({
          type: FETCH_NEW_BOOKINGS_SUCCESS,
          payload:  heatpoints
        });
      
      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  });
};

export const acceptTask = (task) => (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  onValue(singleUserRef(uid), (snapshot) => {
    let profile = snapshot.val();

    runTransaction(singleBookingRef(task.id),(booking) => {
      // Add null checks to prevent property access errors
      if (!booking) {
        console.error('❌ Booking data is null or undefined');
        return null;
      }
      
      const estimate = parseFloat(booking.estimate || 0);
      const convenience_fees = parseFloat(booking.convenience_fees || 0);
      const fleet_admin_comission = parseFloat(booking.fleet_admin_comission || 0);
      
      let fleetCommission_fee = profile.fleetadmin ? ((estimate - convenience_fees) * fleet_admin_comission / 100).toFixed(2) : 0;
      let driver_fee = parseFloat(estimate - (convenience_fees + parseFloat(fleetCommission_fee))).toFixed(2);
      
      if (booking && (booking.requestedDrivers || booking.status === 'ADMIN_QUEUE' || booking.status === 'NEW')) {
          booking.driver = uid;
          booking.driver_image = profile.profile_image ? profile.profile_image : "";
          booking.car_image =  profile.car_image ? profile.car_image : "";
          booking.driver_name = profile.firstName + " " + profile.lastName;
          booking.driver_contact = profile.mobile;
          booking.driver_token = profile.pushToken ? profile.pushToken : '';
          booking.vehicle_number = profile.vehicleNumber ? profile.vehicleNumber : "";
          booking.driverRating = profile.rating ? profile.rating : "0";
          booking.fleetadmin = profile.fleetadmin ? profile.fleetadmin : "";
          booking.driver_share = driver_fee;
          booking.fleetCommission= profile.fleetadmin ? ((parseFloat(booking.estimate) - parseFloat(booking.convenience_fees)) * parseFloat(booking.fleet_admin_comission) / 100).toFixed(2):null,
          booking.status = "ACCEPTED";
          booking.driverDeviceId = task.driverDeviceId? task.driverDeviceId: null;
          booking.requestedDrivers = null;
          booking.driverEstimates = null;

          // Clear auto search related fields when driver accepts
          booking.autoSearchActive = null;
          booking.autoSearchTimestamp = null;
          booking.automaticSearch = null;
          booking.cancelledBy = null;
          booking.cardPaymentAmount = null;
          booking.cashPaymentAmount = null;
          booking.discount = null;
          booking.dropAdress = null;
          booking.id = null;
          booking.pickupAddress = null;
          booking.previousDriver = null;
          booking.previousDriverToken = null;
          booking.reason = null;
          booking.wasAccepted = null;

          return booking;
        }
      })
      .then(() => {
        get(singleBookingRef(task.id))
          .then((snapshot) => {
            if (!snapshot.exists()) {
              return;
            } else {
              let requestedDrivers =
                snapshot.val() && snapshot.val().requestedDrivers;
              let driverId = snapshot.val() && snapshot.val().driver;

              if (requestedDrivers == undefined && driverId === uid) {
                updateProfile({ queue: snapshot.val().category === "delivery" ? false : true })(dispatch);
                if(task.customer_token){
                  RequestPushMsg(task.customer_token, {
                    title:
                      store.getState().languagedata.defaultLanguage
                        .notification_title,
                    msg:
                    profile.firstName +
                      store.getState().languagedata.defaultLanguage
                        .accept_booking_request,
                    screen: "BookedCab",
                    params: { bookingId: task.id },
                  });
                }

                const driverLocation = store.getState().gpsdata.location;

                push(trackingRef(task.id), {
                  at: new Date().getTime(),
                  status: "ACCEPTED",
                  lat: driverLocation.lat,
                  lng: driverLocation.lng,
                });

                dispatch({
                  type: ACCEPT_TASK,
                  payload: { task: task },
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
  },{onlyOnce:true});
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  runTransaction(singleBookingRef(bookingId), (booking) => {
      if (booking && booking.requestedDrivers) {
        if (
          booking.requestedDrivers !== null &&
          Object.keys(booking.requestedDrivers).length === 1
        ) {
          booking.status = "NEW";
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          if(booking.customer_token){
            RequestPushMsg(booking.customer_token, {
              title:
                store.getState().languagedata.defaultLanguage.notification_title,
              msg:
                store.getState().languagedata.defaultLanguage.booking_cancelled +
                bookingId,
              screen: "BookedCab",
              params: { bookingId: bookingId },
            });
          }
          dispatch({
            type: CANCEL_TASK,
            payload: { uid: uid, bookingId: bookingId },
          });
        }else{
          delete booking.requestedDrivers[uid];
        }
        if(booking.driverOffers && booking.driverOffers[uid]){
          delete booking.driverOffers[uid];
        }
        if(booking.selectedBid && booking.selectedBid.driver === uid){
          delete booking.selectedBid;
        }
        return booking;
      }
    });
};

export const fetchOrderListQueue = () => async (dispatch) => {
  const { bookingRef } = firebase;
  
  dispatch({
    type: FETCH_ORDER_LIST_QUEUE,
    payload: null,
  });

  try {
    console.log("🔍 Fetching orders for driver queue...");
    
    // Get all bookings with ADMIN_QUEUE status (no driver assigned)
    const adminQueueQuery = query(
      bookingRef,
      orderByChild('status'),
      equalTo('ADMIN_QUEUE')
    );
    
    const adminQueueSnapshot = await get(adminQueueQuery);
    let adminQueueOrders = [];
    
    if (adminQueueSnapshot.exists()) {
      const adminQueueData = adminQueueSnapshot.val();
      adminQueueOrders = Object.keys(adminQueueData)
        .filter(key => !adminQueueData[key].driver) // Only orders without driver
        .map(key => ({
          ...adminQueueData[key],
          id: key,
          source: 'admin_queue'
        }));
      console.log("🔍 Found admin queue orders:", adminQueueOrders.length);
    }

    // Get all bookings with NEW status (no driver assigned)
    const newOrdersQuery = query(
      bookingRef,
      orderByChild('status'),
      equalTo('NEW')
    );
    
    const newOrdersSnapshot = await get(newOrdersQuery);
    let newOrders = [];
    
    if (newOrdersSnapshot.exists()) {
      const newOrdersData = newOrdersSnapshot.val();
      newOrders = Object.keys(newOrdersData)
        .filter(key => !newOrdersData[key].driver) // Only orders without driver
        .map(key => ({
          ...newOrdersData[key],
          id: key,
          source: 'new_order'
        }));
      console.log("🔍 Found new orders:", newOrders.length);
    }

    // Combine both order types
    const allOrders = [...adminQueueOrders, ...newOrders];
    console.log("🔍 Total available orders:", allOrders.length);

    dispatch({
      type: FETCH_ORDER_LIST_QUEUE_SUCCESS,
      payload: allOrders,
    });
    
  } catch (error) {
    console.error('Error fetching order list queue:', error);
    dispatch({
      type: FETCH_ORDER_LIST_QUEUE_FAILED,
      payload: error.message
    });
  }
};